import React, { useState } from 'react';
import Swal from 'sweetalert2';
import {db} from '../../FirebaseConfig';
import { ref, set, push } from "firebase/database";
import './contact.css';

const ContactForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: '',
    });

    const [errors, setErrors] = useState({
        name: '',
        email: '',
        subject: '',
        message: '',
    });

    const validateEmail = (email) => {
        const emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
        return email.match(emailPattern) ? '' : 'Invalid email address.';
    };

    const validateField = (name, value) => {
        let error = '';
        if (!value.trim()) {
            error = 'This field is required.';
        } else if (name === 'email') {
            error = validateEmail(value);
        }
        setErrors((prevErrors) => ({ ...prevErrors, [name]: error }));
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
        validateField(name, value);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        // Check for validation errors before submitting
        if (Object.values(errors).some((error) => error) || Object.values(formData).some((value) => !value.trim())) {
            Swal.fire({
                icon: 'error',
                title: 'Validation Error',
                text: 'Please fill in all fields correctly before submitting.',
            });
            return;
        }

        try {
            const contactRef = push(ref(db, 'contactForm'));
            await set(contactRef, {
                ...formData,
                date: new Date().toLocaleString(),
            });

            Swal.fire({
                icon: 'success',
                title: 'Success!',
                text: 'Your message has been sent!',
            });

            setFormData({
                name: '',
                email: '',
                subject: '',
                message: '',
            });
        } catch (error) {
            console.error('Error submitting contact form:', error);
            Swal.fire({
                icon: 'error',
                title: 'Submission Error',
                text: 'Something went wrong. Please try again later.',
            });
        }
    };

    return (
        <>
            <form className="contact_form" onSubmit={handleSubmit} noValidate>
                <div className="col-md-10">
                    <div className="form-group">
                        <input
                            type="text"
                            className="form-control"
                            id="name"
                            name="name"
                            placeholder="Enter your name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                        {errors.name && <div className="error">{errors.name}</div>}
                    </div>
                    <div className="form-group">
                        <input
                            type="email"
                            className="form-control"
                            id="email"
                            name="email"
                            placeholder="Enter email address"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                        {errors.email && <div className="error">{errors.email}</div>}
                    </div>
                    <div className="form-group">
                        <input
                            type="text"
                            className="form-control"
                            id="subject"
                            name="subject"
                            placeholder="Enter Subject"
                            value={formData.subject}
                            onChange={handleChange}
                            required
                        />
                        {errors.subject && <div className="error">{errors.subject}</div>}
                    </div>
                </div>
                <div className="col-md-10">
                    <div className="form-group">
                        <textarea
                            className="form-control"
                            name="message"
                            id="message"
                            rows="2"
                            placeholder="Enter Message"
                            value={formData.message}
                            onChange={handleChange}
                            required
                        ></textarea>
                        {errors.message && <div className="error">{errors.message}</div>}
                    </div>
                </div>
                <div className="col-md-12 mt-3 text-right">
                    <button type="submit" className="btn primary-btn2">
                        Send Message
                    </button>
                </div>
            </form>
        </>
    );
};

export default ContactForm;
